'use client'
import { useHeaderTheme } from '@/providers/HeaderTheme'
import Link from 'next/link'
import { usePathname } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import { useAuth } from '@/hooks/useAuth'

import type { Header } from '@/payload-types'

import { Logo } from '@/components/Logo/Logo'
import { HeaderNav } from './Nav'
import { MobileBottomNav } from '@/components/MobileBottomNav'
import { MobileMenu } from '@/components/MobileMenu'
import Image from 'next/image'

interface HeaderClientProps {
  data: Header
}

export const HeaderClient: React.FC<HeaderClientProps> = ({ data }) => {
  /* Storing the value in a useState to avoid hydration errors */
  const [theme, setTheme] = useState<string | null>(null)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { headerTheme, setHeaderTheme } = useHeaderTheme()
  const { isLoggedIn, loading } = useAuth()
  const pathname = usePathname()

  useEffect(() => {
    setHeaderTheme(null)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  useEffect(() => {
    if (headerTheme && headerTheme !== theme) setTheme(headerTheme)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerTheme])

  const handleMenuClick = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  return (
    <>
      <header className="z-9999 fixed left-0 right-0 top-0 bg-white/30 backdrop-blur-sm">
        <div className="container px-4">
          <div className="flex justify-between py-4 max-w-full overflow-hidden">
            <Link href="/">
              <Logo loading="eager" priority="high" />
            </Link>
            <div className="hidden items-center justify-center md:gap-16 md:flex">
              {/* Dynamic dashboard/login link */}
              {!loading && (
                <Link href={isLoggedIn ? '/dashboard' : '/login'}>
                  <Image src="/User.svg" alt="User Icon" width={40} height={40} />
                </Link>
              )}
              <HeaderNav data={data} />
            </div>
          </div>
        </div>
      </header>

      <MobileBottomNav onMenuClick={handleMenuClick} />
      <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} data={data} />
    </>
  )
}
